import type { ChinaMapRegionId } from "@-/dev.improve.haniverse.data.china-map";
import {
  ToolbarPillRow,
  ToolbarViewButton,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { CHINA_MAP_REGION_COPY } from "#china-map-region-copy";
import { AVAILABLE_MAP_REGION_IDS } from "#map-available-regions";

/**
 * The Map toolbar's tabs: one map per region, in the row the Search and Stats toolbars use for
 * theirs. The Map is a single page, so the selection is state, not a route. Only regions with
 * places are offered (`AVAILABLE_MAP_REGION_IDS`); the toolbar renders this only when there is a choice.
 */
export function MapRegionTabs({
  onSelect,
  regionId,
}: {
  onSelect: (regionId: ChinaMapRegionId) => void;
  regionId: ChinaMapRegionId;
}) {
  return (
    <ToolbarPillRow
      accessibilityRole="tablist"
      contentContainerClassName="gap-0.5 p-1"
      hasLeadingActions
      testID="map-region-tabs"
    >
      {AVAILABLE_MAP_REGION_IDS.map((id) => (
        <ToolbarViewButton
          key={id}
          label={CHINA_MAP_REGION_COPY[id].label}
          onPress={() => onSelect(id)}
          selected={id === regionId}
          testID={`map-region-tab-${id}`}
        />
      ))}
    </ToolbarPillRow>
  );
}
